import { Component } from 'vue-property-decorator';
import { LANGTAG, MD } from '../global_vars';
import { animateText, makeFormData, simpleObjectCopy } from '../utils/miscellanea';
import GFade from '../components/gfade/GFade';
import * as basicLightbox from 'basiclightbox';
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import Event from '../utils/Event';
import ContactForm from '../mixins/ContactForm';
import { mixins } from 'vue-class-component';
import { State } from '../utils/fetch';
import { success, warning } from '../utils/Toast';
import Form from '../utils/Form';
// import anime from 'animejs/lib/anime.es.js';
// @ts-ignore

interface ContactData {
  name: string;
  phone: string;
  email: string;
  city: string;
  company: string;
  message: string;
  agreement: boolean;
}

@Component({
  components: {
    GFade,
  }
})
export default class VMFrch extends mixins(ContactForm) {
  contactType = 'phone';

  public form = new Form<ContactData>({
    city: '',
    name: '',
    phone: '',
    company: '',
    message: '',
    email: '',
    agreement: false
  });

  protected requiredFields = ['name', 'city'];
  private lbInstance!: basicLightbox.BasicLightBox | null;

  mounted(): void {
    if (LANGTAG == 'ru') {
      this.requiredFields.push('agreement');
    }

    Event.listen('close-agreement', () => {
      this.lbInstance?.close();
    });

    if (MD.mobile()) return;
    animateText(<HTMLElement>this.$refs.title).then();
  }

  public async send() {
    this.checkForm();

    if (!this.isFormReady) return;

    if (this.form.data.phone == '' && this.form.data.email == '') {
      this.form.errors.add('phone', 'empty field');
      this.form.errors.add('email', 'empty field');
      return;
    } else {
      this.form.errors.clear('phone');
      this.form.errors.clear('email');
    }

    const form = makeFormData(simpleObjectCopy(this.form.data));
    form.append(this._token, '1');

    const response = await this._http.fetchJSON<any>(`/index.php?option=com_xcm&task=send_message`, {
      method: 'POST',
      body: form
    });

    if (response.state == State.SUCCESS) {
      success(response.body.message);
      this.form.errors.clear();
      this.form.clear();
    } else {
      warning(response.message, 'Ошибка');
    }
  }

  openAgreement(key: string) {
    this.lbInstance = basicLightbox.create(
      document.querySelector(`#agreement`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }
}
